import { render, staticRenderFns } from "./classify-nav.vue?vue&type=template&id=b57fd196&"
import script from "./classify-nav.vue?vue&type=script&lang=js&"
export * from "./classify-nav.vue?vue&type=script&lang=js&"
import style0 from "./classify-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports